import React from 'react';
import styled from 'styled-components/macro';

const InfoBox = ({ children, ...props }) => {
    return (
        <StyledInfoBox {...props}>
            {children}
        </StyledInfoBox>
    );
};

export default InfoBox;

const StyledInfoBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    flex: 0 0 auto;
    width: 30rem;
    margin: 2rem;
    padding: 3rem;
    background-color: ${props => props.theme.secondary_color_light};
`;
